import { MenuList } from '@fluentui/react-components';
import {
  ArrowCounterclockwise24Regular,
  Edit20Regular,
  ShiftsActivity20Regular,
} from '@fluentui/react-icons';
import {
  CancellIconLarge,
  GoalMenuItem,
  GoalPopoverSurface,
} from '../style/GoalCard.styled';
import {
  EmployeeGoal,
  StatusDisplayText,
} from 'src/tabs/models/GoalsInterfaces';
import { useContext } from 'react';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { CloseBackground } from './ActionsPopup.styled';

interface ActionsPopupProps {
  isMenuVisible: boolean;
  setIsMenuVisible: React.Dispatch<React.SetStateAction<boolean>>;
  bottomActionsShowConditions: boolean;
  showGoalMenu: boolean;
  rowName: string;
  setIsDefferingGoal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEditingCard: () => void;
  setEditProgressComment: React.Dispatch<React.SetStateAction<boolean>>;
  restoreGoal: () => void;
  showCancelButton: boolean;
  setIsCancelingGoal: React.Dispatch<React.SetStateAction<boolean>>;
  setGoalTextFieldValue: React.Dispatch<React.SetStateAction<string>>;
  goal: EmployeeGoal;
}

export const ActionsPopup = ({
  setIsMenuVisible,
  rowName,
  setIsDefferingGoal,
  setIsEditingCard,
  setEditProgressComment,
  restoreGoal,
  showCancelButton,
  setIsCancelingGoal,
  setGoalTextFieldValue,
  goal,
}: ActionsPopupProps) => {
  const { isMobile } = useContext(TeamsFxContext);

  const editButtonClickHandler = () => {
    if (rowName === StatusDisplayText.DRAFT) {
      setIsEditingCard();
    }
    if (rowName === StatusDisplayText.IN_PROGRESS) {
      setEditProgressComment(true);
    }
    setIsMenuVisible(false);
  };

  return (
    <>
      {isMobile && <CloseBackground />}
      <GoalPopoverSurface isMobile={isMobile}>
        {!isMobile && <h1>More actions</h1>}
        <MenuList>
          {(rowName === StatusDisplayText.APPROVED ||
            rowName === StatusDisplayText.IN_PROGRESS) && (
            <GoalMenuItem
              isMobile={isMobile}
              icon={<ShiftsActivity20Regular />}
              onClick={() => {
                setIsDefferingGoal(true);
                setIsMenuVisible(false);
              }}
            >
              Defer
            </GoalMenuItem>
          )}
          {(rowName === StatusDisplayText.IN_PROGRESS ||
            rowName === StatusDisplayText.DRAFT) && (
            <GoalMenuItem
              icon={<Edit20Regular />}
              onClick={editButtonClickHandler}
            >
              {rowName === StatusDisplayText.IN_PROGRESS
                ? 'Edit comment'
                : 'Edit'}
            </GoalMenuItem>
          )}
          {rowName === StatusDisplayText.CLOSED && (
            <GoalMenuItem
              icon={<ArrowCounterclockwise24Regular />}
              onClick={restoreGoal}
            >
              Restore goal
            </GoalMenuItem>
          )}
          {showCancelButton && (
            <GoalMenuItem
              icon={<CancellIconLarge />}
              onClick={() => {
                setIsCancelingGoal(true);
                setIsMenuVisible(false);
                setGoalTextFieldValue(goal.cra0e_progresscomment || '');
              }}
            >
              Cancel
            </GoalMenuItem>
          )}
        </MenuList>
      </GoalPopoverSurface>
    </>
  );
};
